import styled, { css } from 'styled-components';
import { TableContainer, Td, Th } from '../SummaryTablesStyles';

export const TableContainerStyled = styled(TableContainer)`
  min-height: 19.2rem;
  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    min-height: 15.1rem;
  }
`;

type CellVariant = 'plate' | 'model' | 'category' | 'ownership' | 'driver';

type CellProps = {
  cell?: CellVariant;
};

export const ThStyled = styled(Th) <CellProps>`
  ${({ cell }) => {
    if (!cell) return '';
    return {
      plate: css`
        width: 20rem;
        @media (max-width: ${({ theme }) =>
          theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
          width: 15rem;
        }
      `,
      model: css`
        width: 25rem;
        @media (max-width: ${({ theme }) =>
          theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
          width: 20rem;
        }
      `,
      category: css`
        width: 20rem;
        @media (max-width: ${({ theme }) =>
          theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
          width: 15rem;
        }
      `,
      driver: css`
        width: 25rem;
        @media (max-width: ${({ theme }) =>
          theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
          width: 20rem;
        }
      `,
      ownership: css`
        width: 15rem;
        @media (max-width: ${({ theme }) =>
          theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
          width: 12rem;
        }
      `,
    }[cell];
  }}
`;

export const TdStyled = styled(Td)`
  &:last-of-type {
    width: initial;
  }
`;

